<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-booking-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>เพิ่มนัดหมายในปฏิทิน</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData && errorDataBooking">
                            <label>เลขทะเบียนรถ</label>
                            <div class="row">
                                <div class="col-12 col-sm-4">
                                    <div class="field">
                                        <input type="text" 
                                            class="input-field"
                                            :class="{ 'invalid': errorData.licensePlate.blank }"
                                            maxlength="10"
                                            :readonly="isLockLicensePlate"
                                            placeholder="ทะเบียนรถ"
                                            v-model="formData.licensePlate" />
                                        <div class="input-error-message" v-if="errorData.licensePlate.blank">โปรดกรอกทะเบียนรถ</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <div class="field">
                                        <dropdown
                                            v-model="formData.licensePlateProvince"
                                            placeholder="-- เลือกจังหวัด --"
                                            :options="option.licensePlateProvince"
                                            :disabled="isLockLicensePlate"
                                            :classes="{ input: ['input-field', (errorData.licensePlateProvince.blank ? 'invalid' : '')] }"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.licensePlateProvince.blank">โปรดเลือกทะเบียนจังหวัด</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4" v-if="isShowLookupCar && !isCarFieldReady">
                                    <div class="field">
                                        <button class="btn btn-red" @click="lookupCarLicense()">ค้นหาทะเบียนลูกค้า</button>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center" v-if="isNewCustomer">
                                <button class="btn btn-block btn-dash btn-grey-outline" @click="showCarField()">เป็นลูกค้าใหม่</button>
                            </div>

                            <template v-if="isCarFieldReady">
                                <div class="row">
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>ยี่ห้อรถ</label>
                                            <dropdown
                                                v-model="formData.carBrand"
                                                placeholder="ยี่ห้อรถ"
                                                :options="option.carBrand"
                                                :classes="{ input: ['input-field', (errorData.carBrand.blank ? 'invalid' : '')] }"
                                                @change="loadCarModel($event)"
                                            ></dropdown>
                                            <div class="input-error-message" v-if="errorData.carBrand.blank">โปรดเลือกยี่ห้อรถ</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>รุ่นรถ</label>
                                            <dropdown
                                                v-model="formData.carModel"
                                                placeholder="รุ่นรถ"
                                                :options="option.carModel"
                                                :classes="{ input: ['input-field', (errorData.carModel.blank ? 'invalid' : '')] }"
                                                @change="loadCarYearSerie($event)"
                                            ></dropdown>
                                            <div class="input-error-message" v-if="errorData.carModel.blank">โปรดเลือกรุ่นรถ</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label class="optional">ปีรถ</label>
                                            <dropdown
                                                v-model="formData.carYearSerie"
                                                placeholder="ปีรถ"
                                                :options="option.carYearSerie"
                                                :classes="{ input: 'input-field' }"
                                            ></dropdown>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>ชื่อผู้ติดต่อนัดหมาย</label>
                                            <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.customerFirstName.blank }"
                                                maxlength="100"
                                                placeholder="ชื่อจริง"
                                                v-model="formData.customerFirstName" />
                                            <div class="input-error-message" v-if="errorData.customerFirstName.blank">โปรดกรอกชื่อผู้ติดต่อนัดหมาย</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>นามสกุลผู้ติดต่อนัดหมาย</label>
                                            <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.customerLastName.blank }"
                                                maxlength="100"
                                                placeholder="นามสกุล"
                                                v-model="formData.customerLastName" />
                                            <div class="input-error-message" v-if="errorData.customerLastName.blank">โปรดกรอกนามสกุลผู้ติดต่อนัดหมาย</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>เบอร์ติดต่อผู้นัดหมาย</label>
                                            <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.customerTel.blank }"
                                                maxlength="20"
                                                placeholder="เบอร์ติดต่อ"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.customerTel" />
                                            <div class="input-error-message" v-if="errorData.customerTel.blank">โปรดกรอกเบอร์ติดต่อ</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>วันที่นัดหมาย</label>
                                            <div class="input-datepicker">
                                                <datepicker :input-class="[ 'input-field', (errorData.appointmentDate.blank ? 'invalid' : '') ]"
                                                    calendar-class="gadget-datepicker-box"
                                                    format="d/M/yyyy"
                                                    v-model="formData.appointmentDate">
                                                </datepicker>
                                                <b-icon icon="calendar2-minus"></b-icon>
                                            </div>
                                            <div class="input-error-message" v-if="errorData.appointmentDate.blank">โปรดใส่วันที่ทำรายการ</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-4">
                                        <div class="field">
                                            <label>เวลาโดยประมาณ</label>
                                            <dropdown
                                                v-model="formData.appointmentTime"
                                                :options="option.time"
                                                :classes="{ input: ['input-field', (errorData.appointmentTime.blank ? 'invalid' : '')] }"
                                            ></dropdown>
                                            <div class="input-error-message" v-if="errorData.appointmentDate.blank">โปรดเลือกเวลานัดหมาย</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="field">
                                            <label>หัวข้อการนัดหมาย</label>
                                            <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.topic.blank }"
                                                maxlength="100"
                                                placeholder="เรื่องนัดหมาย"
                                                v-model="formData.topic" />
                                            <div class="input-error-message" v-if="errorData.topic.blank">โปรดกรอกหัวข้อการนัดหมาย</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-4" v-if="!isShowReserveProduct">
                                    <button class="btn btn-block btn-dash btn-grey-outline" @click="openReserveProduct()">สั่งจองสินค้า</button>
                                </div>

                                <template v-if="isShowReserveProduct">
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="field">
                                                <label>ช่องทางสั่งจอง</label>
                                                <dropdown
                                                    v-model="formData.reserve.channel"
                                                    placeholder="-- เลือกช่องทางการจอง --"
                                                    :options="option.channel"
                                                    :classes="{ input: ['input-field', (errorDataBooking.channel.blank ? 'invalid' : '')] }"
                                                ></dropdown>
                                                <div class="input-error-message" v-if="errorDataBooking.channel.blank">โปรดเลือกช่องทางสั่งจอง</div>
                                            </div>
                                        </div>
                                    </div>

                                    <perfect-scrollbar class="mt-3">
                                        <table v-if="productList.length > 0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th>สินค้า</th>
                                                    <th class="text-center">จำนวน</th>
                                                    <th class="text-right">ราคารวม</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in productList" :key="index">
                                                    <td class="text-center">{{ (index + 1) }}</td>
                                                    <td>
                                                        <span class="text-nowrap" v-if="item.sku">SKU: {{ item.sku }}</span>
                                                        {{ item.name }}
                                                    </td>
                                                    <td class="text-center">{{ item.quantity }}</td>
                                                    <td>
                                                        <div class="input-price">
                                                            <input type="text" class="input-field text-right" readonly :value="item.price" />
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <button class="btn btn-sm btn-red text-nowrap" @click="removeBookingProduct(index)">ลบสินค้า</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </perfect-scrollbar>

                                    <div class="input-error-message mt-3" v-if="errorDataBooking.product.blank">โปรดเลือกสินค้าสั่งจอง</div>

                                    <div class="text-center mt-3">
                                        <button class="btn btn-dash btn-block btn-grey-outline" @click="openModalProduct()">เพิ่มสินค้า</button>
                                    </div>
                                </template>

                                <div class="mt-4 text-right">
                                    <button class="btn btn-main" @click="saveAppointment()">บันทึกการนัดหมาย</button>
                                    <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            
            <job-modal-product
                :isDisplay="isShowModalProduct"
                @hide="closeModalProduct()"
                @addProduct="addProduct($event)">
            </job-modal-product>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import JobModalProduct from '@/components/job/shared/ModalProduct';
import ModelStockSyncData from '@/resources/models/StockSyncData';
import DBBooking from '@/database/Booking';
import DBStock from '@/database/Stock';
import DBCustomer from '@/database/Customer';
import OptionTime from '@/database/staticOption/Time';
import OptionChannel from '@/database/staticOption/Channel';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    components: {
        JobModalProduct
    },
    data() {
        return {
            isActive: false,
            isNewCustomer: false,
            isCarFieldReady: false,
            isShowLookupCar: true,
            isLockLicensePlate: false,
            formData: null,
            errorData: null,
            errorDataBooking: null,
            option: {
                licensePlateProvince: [],
                carBrand: [],
                carModel: [],
                carYearSerie: [],
                time: [],
                channel: []
            },
            isShowReserveProduct: false,
            isShowModalProduct: false,
            productList: []
        };
    },
    props: {
        isDisplay: Boolean,
        bookingDate: Date
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.isShowReserveProduct = false;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.isLockLicensePlate = false;
                this.isNewCustomer = false;
                this.isCarFieldReady = false;

                this.formData = this.initFormData();
                this.errorData = this.initValidateData();
                this.errorDataBooking = this.initValidateDataBooking();
            }
        }
    },
    mounted() {
        this.initOptionData();
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        initFormData() {
            this.productList = [];

            return {
                keyDate: '',
                key: '',
                licensePlate: '',
                licensePlateProvince: '',
                carBrand: '',
                carModel: '',
                carYearSerie: '',
                customerFirstName: '',
                customerLastName: '',
                customerTel: '',
                appointmentDate: this.bookingDate || new Date(),
                appointmentTime: '',
                topic: '',
                status: '',
                reserve: {
                    bookingId: '',
                    jobNumber: '',
                    channel: '',
                    product: []
                }
            }
        },
        async initOptionData() {
            this.option.licensePlateProvince = OptionLicensePlateProvince.option;

            this.option.carBrand = await this.$AppUtility.setupCarBrandOption();
            this.option.carModel = [];
            this.option.carYearSerie = [];

            this.option.time = OptionTime.option;
            this.option.channel = OptionChannel.option;
        },
        initValidateData() {
            return {
                licensePlate: { blank: false },
                licensePlateProvince: { blank: false },
                carBrand: { blank: false },
                carModel: { blank: false },
                customerFirstName: { blank: false },
                customerLastName: { blank: false },
                customerTel: { blank: false },
                appointmentDate: { blank: false },
                appointmentTime: { blank: false },
                topic: { blank: false }
            }
        },
        initValidateDataBooking() {
            return {
                channel: { blank: false },
                product: { blank: false }
            }
        },
        async lookupCarLicense() {
            if (this.validateLookup()) {
                const loader = this.$AppUtility.renderLoadBackdrop();

                // Check if license is exist
                const customerData = await DBCustomer.getDetailByLicensePlate(this.formData.licensePlate, this.formData.licensePlateProvince);

                if (customerData) {
                    this.formData.carBrand = customerData.carBrand;
                    this.formData.carModel = customerData.carModel;
                    this.formData.carYearSerie = customerData.carYearSerie;
                    this.formData.customerFirstName = customerData.customerFirstName;
                    this.formData.customerLastName = customerData.customerLastName;
                    this.formData.customerTel = customerData.customerTel;

                    this.showCarField();
                } else {
                    this.isNewCustomer = true;
                }

                loader.hide();
            }
        },
        validateLookup() {
            this.errorData = this.initValidateData();
            let valid = true;

            if (!this.formData.licensePlate.trim()) {
                this.errorData.licensePlate.blank = true;
                valid = false;
            }
            if (!this.formData.licensePlateProvince.trim()) {
                this.errorData.licensePlateProvince.blank = true;
                valid = false;
            }

            return valid;
        },
        showCarField() {
            this.isLockLicensePlate = true;
            this.isNewCustomer = false;
            this.isCarFieldReady = true;
        },
        async loadCarModel(value) {
            if (value) {
                const param = {
                    carBrand: value
                };

                this.option.carModel = await this.$AppUtility.setupCarModelOption(param);
            } else {
                this.option.carModel = [];
                this.option.carYearSerie = [];
                this.formData.carModel = '';
                this.formData.carYearSerie = '';
            }
        },
        async loadCarYearSerie(value) {
            this.formData.carYearSerie = '';

            if (value) {
                const param = { 
                    carBrand: this.formData.carBrand,
                    carModel: value
                };

                this.option.carYearSerie = await this.$AppUtility.setupCarYearSerieOption(param);
            } else {
                this.option.carYearSerie = [];
                this.formData.carYearSerie = '';
            }
        },
        openReserveProduct() {
            this.isShowReserveProduct = true;
        },
        cancelReserveProduct() {
            this.isShowReserveProduct = false;
        },
        openModalProduct() {
            this.isShowModalProduct = true;
        },
        closeModalProduct() {
            this.isShowModalProduct = false;
        },
        addProduct(item) {
            this.productList.push(this.mapTableData(item));
            this.formData.reserve.product.push(this.mapStoreData(item));

            this.errorDataBooking.channel.blank = false;

            this.closeModalProduct();
        },
        removeBookingProduct(index) {
            this.productList.splice(index, 1);
        },
        mapStoreData(data) {
            return {
                inventoryData: data.inventoryData,
                inventoryKey: data.inventoryKey,
                productData: data.productData,
                quantity: data.quantity
            };
        },
        mapTableData(data) {
            return {
                sku: data.inventoryData.sku,
                name: data.productData.name,
                quantity: data.quantity,
                price: data.quantity * parseFloat(data.inventoryData.price)
            };
        },
        async saveAppointment() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                await DBBooking.save(this.setupAppointmentData());

                // Reserve Stock
                await this.reserveStockData();

                // Update and Save Customer Data
                await DBCustomer.saveCustomerData(
                    this.formData.licensePlate,
                    this.formData.licensePlateProvince,
                    '',
                    this.formData.carBrand,
                    this.formData.carModel,
                    this.formData.carYearSerie,
                    this.formData.customerFirstName,
                    this.formData.customerLastName,
                    this.formData.customerTel,
                    false
                );
                                                
                this.hide(true);
                loader.hide();
            }
        },
        setupAppointmentData() {
            this.formData.keyDate = this.formatKeyDate(this.formData.appointmentDate);

            if (this.isShowReserveProduct) {
                this.formData.reserve.bookingId = this.generateBookingId();
            }

            return {
                keyDate: this.formData.keyDate,
                appointment: this.formData
            }
        },
        async reserveStockData() {
            for (const item of this.formData.reserve.product) {
                const syncData = ModelStockSyncData.data();
                syncData.key = item.inventoryKey;
                syncData.operand = DBStock.operandAction().reserve;
                syncData.amount = item.quantity;

                await DBStock.reserveStockData(syncData);
            }
        },
        generateBookingId() {
            const chars = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
            let result = '';

            for (let index = 0; index < 12; index++) {
                const random = Math.floor(Math.random() * chars.length);

                result = result + chars.charAt(random);
            }

            return result;
        },
        formatKeyDate(date) {
            let output = '';

            const month = date.getMonth() + 1;
            const day = date.getDate();
            const year = date.getFullYear();
    
            output = [year, month, day].join('-');
    
            return output;
        },
        validateData() {
            this.errorData = this.initValidateData();
            this.errorDataBooking = this.initValidateDataBooking();
            let valid = true;

            for (const property in this.errorData) {
                if (typeof this.formData[property] === 'string' || this.formData[property] instanceof String) {
                    if (!this.formData[property].trim()) {
                        this.errorData[property].blank = true;
                        valid = false;
                    }
                }
            }

            if (this.isShowReserveProduct) {
                for (const property in this.errorDataBooking) {
                    if (typeof this.formData.reserve[property] === 'string' || this.formData.reserve[property] instanceof String) {
                        if (!this.formData.reserve[property].trim()) {
                            this.errorDataBooking[property].blank = true;
                            valid = false;
                        }
                    }

                    if (this.formData.reserve[property].constructor === Array) {
                        if (this.formData.reserve[property].length === 0) {
                            this.errorDataBooking[property].blank = true;
                            valid = false;
                        }
                    }
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-booking-form {
    max-width: 800px;
}
</style>